import posthog from 'posthog-js';
import { ReactNode, useEffect } from 'react';
import { PostHogProvider } from '@posthog/react';
import { POSTHOG_INIT } from 'src/constants/posthog.constants';

interface PHProviderProps {
  isProduction?: boolean;
  children: ReactNode;
}

export function PHProvider({ isProduction = false, children }: PHProviderProps) {
  useEffect(() => {
    if (isProduction) {
      posthog.init(POSTHOG_INIT.KEY, {
        api_host: POSTHOG_INIT.API_HOST,
        defaults: POSTHOG_INIT.DEFAULTS as any,
      });
    }
  }, [isProduction]);

  if (isProduction) {
    return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
  }

  return <>{children}</>;
}
